import { render, staticRenderFns } from "./BizInsuranceExcelCompareModal.vue?vue&type=template&id=9bc91d78&"
import script from "./BizInsuranceExcelCompareModal.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceExcelCompareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports